/* ============================================================
   NIEL MAISON — Theme interactions
   ============================================================ */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Preloader ---------- */
  function markReady() {
    // Signals the intro is over — reveals Shopify's cookie banner (kept hidden until now)
    document.documentElement.classList.add('nm-ready');
  }
  function initPreloader() {
    var pre = document.querySelector('.preloader');
    if (!pre) { markReady(); return; }
    var seen = false;
    try { seen = !!sessionStorage.getItem('nm-pre'); } catch (e) {}
    if (seen || reduceMotion) { pre.remove(); markReady(); return; }
    try { sessionStorage.setItem('nm-pre', '1'); } catch (e) {}
    document.body.style.overflow = 'hidden';
    window.setTimeout(function () {
      pre.classList.add('is-done');
      document.body.style.overflow = '';
      markReady();
      window.setTimeout(function () { if (pre.parentNode) pre.parentNode.removeChild(pre); }, 750);
    }, 2400);
  }

  /* ---------- Page transitions ---------- */
  function initTransitions() {
    if (reduceMotion) return;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || a.target === '_blank' || a.hasAttribute('download')) return;
      // Only intercept http(s)/relative links — never mailto:, tel:, javascript:, etc.
      if (a.protocol && a.protocol !== 'http:' && a.protocol !== 'https:') return;
      if (a.host && a.host !== location.host) return;
      if (a.hasAttribute('data-no-transition')) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      document.body.classList.add('page-exit');
      // Use assign with the resolved same-origin URL, not the raw attribute
      window.setTimeout(function () { window.location.assign(a.href); }, 320);
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) document.body.classList.remove('page-exit');
    });
  }

  /* ---------- Sticky add-to-cart (mobile PDP) ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var form = document.querySelector('.pdp__form');
    if (!bar || !form) return;
    var ticking = false;
    function check() {
      bar.classList.toggle('is-visible', form.getBoundingClientRect().bottom < 0);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(check); ticking = true; }
    }, { passive: true });
    check();
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal, .line-mask, .media-zoom');
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Header state (hide on scroll down, solid after hero) ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var last = 0;
    var isHome = document.body.classList.contains('template-index');
    var announcement = document.querySelector('.announcement');
    function onScroll() {
      var y = window.scrollY;
      var solidPoint = isHome ? window.innerHeight * 0.82 : -1;
      header.classList.toggle('is-solid', y > solidPoint);
      if (announcement) header.style.top = Math.max(0, announcement.offsetHeight - y) + 'px';
      if (y > last && y > 300) header.classList.add('is-hidden');
      else header.classList.remove('is-hidden');
      last = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Parallax on hero media ---------- */
  function initParallax() {
    if (reduceMotion) return;
    var items = document.querySelectorAll('[data-parallax]');
    if (!items.length) return;
    var ticking = false;
    function update() {
      items.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.15;
        var rect = el.parentElement.getBoundingClientRect();
        var offset = (rect.top) * -speed;
        el.style.transform = 'translate3d(0,' + offset.toFixed(2) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Predictive search ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function initSearch() {
    var overlay = document.querySelector('[data-search-overlay]');
    if (!overlay) return;
    var input = overlay.querySelector('[data-search-input]');
    var results = overlay.querySelector('[data-search-results]');
    var hint = overlay.querySelector('[data-search-hint]');
    function open() { overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; window.setTimeout(function () { input.focus(); }, 300); }
    function close() { overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
    document.querySelectorAll('[data-search-toggle]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    overlay.querySelectorAll('[data-search-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    var timer;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { results.innerHTML = ''; hint.textContent = 'Escribe para descubrir'; return; }
      timer = window.setTimeout(function () {
        hint.textContent = 'Buscando…';
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) { hint.textContent = 'Sin resultados para “' + q + '”'; results.innerHTML = ''; return; }
            hint.textContent = products.length + (products.length > 1 ? ' resultados' : ' resultado');
            results.innerHTML = products.map(function (p) {
              var media = p.image ? '<div class="search-result__media"><img src="' + esc(p.image) + '" alt="" loading="lazy"></div>' : '';
              var price = p.price ? '<div class="search-result__price">' + esc(p.price) + '</div>' : '';
              return '<a class="search-result" href="' + esc(p.url) + '" data-no-transition>' + media +
                '<div class="search-result__title">' + esc(p.title) + '</div>' + price + '</a>';
            }).join('');
          })
          .catch(function () { hint.textContent = 'No se pudo buscar ahora.'; });
      }, 250);
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-open]');
    var menu = document.querySelector('[data-mobile-menu]');
    var close = document.querySelector('[data-menu-close]');
    if (!toggle || !menu) return;
    function open() { menu.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function shut() { menu.classList.remove('is-open'); document.body.style.overflow = ''; }
    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', shut); });
  }

  /* ---------- Accordion ---------- */
  function initAccordion() {
    document.querySelectorAll('.accordion__trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.accordion__item');
        var panel = item.querySelector('.accordion__panel');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open);
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : 0;
      });
    });
  }

  /* ---------- PDP gallery ---------- */
  function initGallery() {
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var srcset = thumb.getAttribute('data-srcset');
        main.src = src;
        if (srcset) main.srcset = srcset;
        document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---------- Qty steppers ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = parseInt(b.getAttribute('data-step'), 10);
          var v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = v;
        });
      });
    });
  }

  /* ---------- Cart (AJAX + drawer) ---------- */
  var Cart = {
    drawer: null, overlay: null,
    init: function () {
      this.drawer = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-cart-overlay]');
      var self = this;

      document.querySelectorAll('[data-cart-toggle]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); self.open(); });
      });
      if (this.overlay) this.overlay.addEventListener('click', function () { self.close(); });
      document.querySelectorAll('[data-cart-close]').forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });

      document.addEventListener('submit', function (e) {
        var form = e.target.closest('form[action$="/cart/add"], form[action*="/cart/add"]');
        if (!form) return;
        e.preventDefault();
        self.add(form);
      });

      document.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-cart-remove]');
        if (rm) { e.preventDefault(); self.change(rm.getAttribute('data-key'), 0); }
      });
    },
    open: function () { if (this.drawer) { this.drawer.classList.add('is-open'); this.overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; } },
    close: function () { if (this.drawer) { this.drawer.classList.remove('is-open'); this.overlay.classList.remove('is-open'); document.body.style.overflow = ''; } },
    add: function (form) {
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Añadiendo…'; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(serialize(form)) })
        .then(function (r) { return r.json(); })
        .then(function () { return Cart.refresh(); })
        .then(function () { Cart.open(); })
        .catch(function () {})
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
    },
    change: function (key, qty) {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function () { return Cart.refresh(); })
        .catch(function () {});
    },
    refresh: function () {
      return fetch('/?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-contents]');
        var current = document.querySelector('[data-cart-contents]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var count = doc.querySelector('[data-cart-count]');
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { if (count) el.textContent = count.textContent; });
      });
    }
  };

  function serialize(form) {
    var data = { items: [] };
    var id = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    data.items.push({ id: id ? id.value : null, quantity: qty ? parseInt(qty.value, 10) || 1 : 1 });
    return data;
  }

  /* ---------- Hero video: make autoplay resilient across browsers ---------- */
  function initHeroVideo() {
    document.querySelectorAll('.hero__media video').forEach(function (v) {
      v.muted = true;              // required for autoplay on most browsers
      v.setAttribute('muted', '');
      v.playsInline = true;
      var tryPlay = function () {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      };
      tryPlay();
      // Some browsers block autoplay until the metadata is ready or on first interaction
      v.addEventListener('canplay', tryPlay, { once: true });
      document.addEventListener('touchstart', tryPlay, { once: true, passive: true });
      document.addEventListener('click', tryPlay, { once: true });
    });
  }

  /* ---------- Boot ---------- */
  function boot() {
    window.__nmBooted = true;
    initHeroVideo();
    initPreloader(); initTransitions(); initStickyAtc();
    initReveal(); initHeader(); initParallax();
    initMobileMenu(); initAccordion(); initGallery(); initQty(); initSearch();
    Cart.init();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
